import "./Cards.scss";

export default function Cards(props) {
  return (
    <div
      className={`Cards ${props.className}`}
      style={{ justifyContent: props.align, ...props.style }}
    >
      {props.lst.map((item, index) => (
        <div className="itens">
          <p>{item.key}</p>
          <p>{item.text}</p>
        </div>
      ))}
    </div>
  );
}

Cards.defaultProps = {
  align: "center",
  className: "",
  lst: [
    {
      key: "Empresas Situação Fiscal",
      text: "2.050",
    },
    {
      key: "Empresas Débitos",
      text: "150",
    },
    {
      key: "Empresas Declarações",
      text: "150",
    },
    {
      key: "Empresas Saldo Devedor.",
      text: "150",
    },
  ],
};
